<template>
  <section class="get-started-section">
    <TwinColorTitle class="title"> Transform your ideas <br /><em>into reality</em> </TwinColorTitle>
    <NavLink :href="Routes.PlanATrip" id="get-started-plan-a-trip">
      <Button color="red" class="get-started-section__plan-now-btn"> Start planning now </Button>
    </NavLink>

    <FourStepPlan :show="mbaExclusive ? 3 : 4" />
  </section>
</template>

<script setup lang="ts">
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'
import Button from '@/components/Theme2/Button.vue'
import started1 from 'app/assets/images/home/started_1.webp'
import started2 from 'app/assets/images/home/started_2.webp'
import started3 from 'app/assets/images/home/started_3.webp'
import started4 from 'app/assets/images/home/started_4.webp'
import { Routes } from '@/constants'
import NavLink from '@/components/NavLink.vue'
import FourStepPlan from '@/modules/LandingPages/Components/FourStepPlan.vue'

defineProps<{ mbaExclusive?: boolean }>()

const steps: {
  step: number
  title: string
  description: string
  image: string
}[] = [
  {
    step: 1,
    title: 'Create your personalized itinerary instantly',
    description: 'Start with your trip ideas and instantly turn them into a custom itinerary.',
    image: started1,
  },
  {
    step: 2,
    title: 'See real-time pricing as you edit your itinerary',
    description: 'Make changes to your trip live and see price updates on the spot.',
    image: started2,
  },
  {
    step: 3,
    title: 'Get local expert help to perfect your trip',
    description: 'Local experts who operate the trip help fine-tune the details of your itinerary.',
    image: started3,
  },
  {
    step: 4,
    title: 'Publish your trip, enjoy the journey, and earn',
    description: 'We handle logistics—just enjoy your trip and start earning.',
    image: started4,
  },
]
</script>

<style lang="scss" scoped>
.get-started-section {
  align-items: center;

  @include mobile {
    @include main-unwrap;
    overflow-x: hidden;
  }

  .title {
    margin-bottom: 20px;
  }
}

.get-started-section__plan-now-btn {
  margin-bottom: 40px;
}

.get-started-section__grid {
  gap: 20px;
  img {
    border-radius: 15px;
    width: 100%;
  }

  @include desktop {
    display: grid;

    &.three-columns {
      grid-template-columns: repeat(3, 1fr);
    }

    &.four-columns {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @include mobile {
    display: flex;
    flex-direction: column;
    justify-items: center;
    margin: 0 var(--site-px);

    img {
      height: 190px;
      width: calc(100% - 10px);
    }
  }
}

.get-started-section__step {
  @include flex-column;

  gap: 10px;
  height: 100%;
  border-left: 1px solid $gray-lighter;
  padding-left: 10px;
}

@include desktop {
  .get-started-section__step-content {
    flex: 1;
  }
}

.get-started-section__number {
  margin: 0 0 30px 0;
  line-height: 1;
  font-size: $text-4xl;
  background: -webkit-linear-gradient(270deg, #1c355e 14.34%, #538c97 85.42%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.get-started-section__title {
  font-weight: 600;
}

.get-started-section__description {
  font-size: $text-base;
  font-weight: 400;
}

.get-started-section__image {
  height: 300px;
}
</style>
